import {
  Form,
  FormItemProps,
  InputNumber as AntdInputNumber,
  InputNumberProps as AntdInputNumberProps,
  Tooltip,
} from "antd";
import { SizeType } from "antd/es/config-provider/SizeContext";
import type { Rule } from "antd/es/form";
import classNames from "clsx";

import { SizeEnum } from "@/types";
import { REQUIRED_VALIDATION_MESSAGE } from "@/utils/constant";

interface NumberInputProps extends FormItemProps {
  name: string;
  label: string;
  placeholder: string;
  size?: SizeEnum;
  step?: number;
  min?: number;
  required?: boolean;
  disabled?: boolean;
  isSeperator?: boolean;
  onChangeListener?: (val: number | string | null) => void;
  otherInputProps?: AntdInputNumberProps;
}

export const NumberInput = ({
  name,
  label,
  placeholder,
  size = SizeEnum.large,
  step = 1,
  min = 0,
  required = false,
  isSeperator = false,
  onChangeListener,
  otherInputProps = {},
  rules = [],
  ...rest
}: NumberInputProps) => {
  const getRules = (): Rule[] => {
    return [...rules, { required, message: REQUIRED_VALIDATION_MESSAGE }];
  };

  return (
    <div
      className={classNames(
        "custom_form_comp_wrapper",
        rest?.hidden && "h-0 overflow-hidden",
        isSeperator && "flex items-center gap-x-2"
      )}
    >
      <label
        htmlFor={name}
        className={classNames(
          "block text-primary-0",
          isSeperator ? "mb-6" : "mb-2"
        )}
      >
        {label}
      </label>
      {isSeperator && (
        <div className="mb-6 flex-[1] basis-40 border border-dashed border-disabled" />
      )}
      <div className={classNames(isSeperator && "basis-[288px]")}>
        <Tooltip trigger="click" title="Please enter a number">
          <div>
            <Form.Item name={name} rules={getRules()} {...rest}>
              <AntdInputNumber
                size={size as SizeType}
                placeholder={placeholder}
                step={step}
                min={min}
                disabled={rest?.disabled}
                onChange={onChangeListener}
                className="bg-neutral-150 text-sm w-full placeholder:text-[#62748E80]/80 border-[#F8FAFC] focus:border-primary-500"
                {...otherInputProps}
              />
            </Form.Item>
          </div>
        </Tooltip>
      </div>
    </div>
  );
};
